import * as React from "react";

const ArchiveIcon = props => (
  <svg xmlns="http://www.w3.org/2000/svg" width={16} height={12} fill="none" {...props}>
    <path
      stroke="#2563EB"
      strokeWidth={0.833}
      d="M15.083 6.415h-2.132c-.58 0-.87 0-1.088.158-.218.156-.31.431-.493.981l-.073.221c-.184.55-.276.825-.494.983-.218.157-.508.157-1.088.157h-3.43c-.58 0-.87 0-1.088-.157-.218-.157-.31-.432-.493-.982l-.073-.221c-.184-.55-.275-.825-.494-.983-.218-.157-.508-.157-1.088-.157H.917m5-2.5L8 5.998m0 0 2.083-2.083M8 5.998V.165"
    />
    <path
      stroke="#2563EB"
      strokeLinecap="round"
      strokeWidth={0.833}
      d="m3.417 3.082-1.432.954c-.39.261-.586.391-.728.563a1.5 1.5 0 0 0-.275.516c-.065.214-.065.449-.065.918v2.982c0 .84 0 1.26.163 1.581a1.5 1.5 0 0 0 .656.656c.32.163.74.163 1.58.163h9.367c.84 0 1.26 0 1.581-.163a1.5 1.5 0 0 0 .656-.656c.163-.32.163-.74.163-1.58V6.032c0-.47 0-.704-.065-.917a1.5 1.5 0 0 0-.276-.516c-.141-.173-.337-.303-.727-.564l-1.432-.954"
    />
  </svg>
);
export default ArchiveIcon;
